/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Assignedpersonforparentalcontact4Inputs */

const de__field_assignedpersonforparentalcontact4 = /** @type {(inputs: _Field_Assignedpersonforparentalcontact4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugewiesene Person für Elternkontakt`)
};

/**

* @param {_Field_Assignedpersonforparentalcontact4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_assignedpersonforparentalcontact4 = /** @type {((inputs?: _Field_Assignedpersonforparentalcontact4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Assignedpersonforparentalcontact4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_assignedpersonforparentalcontact4(inputs)
});
export { _field_assignedpersonforparentalcontact4 as "_field_assignedPersonForParentalContact" }